import {
	Button,
	Card,
	DropdownMenu,
	Flex,
	Heading,
	Link as RLink,
} from '@radix-ui/themes'
import {
	Link,
	useLocation,
	useNavigate,
	useNavigation,
	useOutletContext,
	useSearchParams,
} from '@remix-run/react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { type GetTaxon } from '~/models/ecommerce-providers/sylius/shop/fetch/taxon/get-taxon.ts'
import { type GetTaxons } from '~/models/ecommerce-providers/sylius/shop/fetch/taxon/get-taxons.ts'
import { PRODUCTS_INDEX_I18NEXT, PRODUCTS_INDEX_SEARCH_PARAMS } from '~/routes/($lang).products._index/index.component.tsx'
import { useProductsTaxonNotify } from '~/routes/($lang).products._index/use-products-taxon-notify.tsx'
import { SEARCH_SEARCH_PARAMS } from '~/routes/_layout'
import { type Context } from '~/routes/_layout/root.component.tsx'
import { TaxonFilterDropdown, TaxonFilterList } from '~/routes/($lang).products._index/taxon-filter.tsx'

/* -------------------------------------------------------------------------------------------------
 * TaxonFilter
 * -----------------------------------------------------------------------------------------------*/

type LeftSidebarProps = {
	currentTaxon: GetTaxon | undefined
	taxons: GetTaxons | undefined
}

const LeftSidebar: React.FC<LeftSidebarProps> = ({ currentTaxon, taxons }) => {
	return (
		<>
			<nav className="app-SidePanel sticky hidden p-3 py-4 lg:block">
				<Card size="3">
          <TaxonFilterList currentTaxon={currentTaxon} taxons={taxons} />
				</Card>
			</nav>
      <TaxonFilterDropdown currentTaxon={currentTaxon} taxons={taxons} />
		</>
	)
}
LeftSidebar.displayName = 'LeftSidebar'

/* -----------------------------------------------------------------------------------------------*/

export {
  LeftSidebar,
  type LeftSidebarProps,
}
